'use client';

import { Skeleton } from '@mui/material';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';

import { ChangePasswordSection } from '@/features/auth/components';
import {
  useGetCurrentUserContextQuery,
  useGetUserByIdQuery,
} from '@/features/users/api/usersApi';

import { ProfileInformationSection } from './ProfileInformationSection';
import styles from './ProfilePanel.module.scss';

export function ProfilePanel() {
  const { data: currentUserContextResponse, isLoading: isContextLoading } =
    useGetCurrentUserContextQuery();

  const currentUserContext =
    currentUserContextResponse?.success === true
      ? currentUserContextResponse.data
      : null;
  const userId = currentUserContext?.user?.id || null;

  const { data: userProfileResponse, isLoading: isUserLoading } =
    useGetUserByIdQuery(userId ?? skipToken);
  const userProfile =
    userProfileResponse?.success === true ? userProfileResponse.data : null;
  const userSignature = useMemo(
    () =>
      JSON.stringify({
        id: userProfile?.id || '',
        first_name: userProfile?.first_name || '',
        last_name: userProfile?.last_name || '',
        email: userProfile?.email || '',
        avatar_asset_key: userProfile?.avatar_asset_key || '',
        avatar_url: userProfile?.avatar_url || '',
        avatar: userProfile?.avatar || '',
      }),
    [userProfile],
  );

  if (isContextLoading) {
    return (
      <section className={styles.profilePanel}>
        <div className={styles.loadingCards}>
          <div className={`card-container-glass ${styles.loadingCard}`}>
            <Skeleton variant="rounded" width={180} height={30} />
            <Skeleton variant="rounded" width="100%" height={56} />
            <Skeleton variant="rounded" width="100%" height={56} />
            <Skeleton variant="rounded" width="100%" height={56} />
          </div>
          <div className={`card-container-glass ${styles.loadingCard}`}>
            <Skeleton variant="rounded" width={180} height={30} />
            <Skeleton variant="rounded" width="100%" height={56} />
            <Skeleton variant="rounded" width="100%" height={56} />
            <Skeleton variant="rounded" width="100%" height={56} />
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={styles.profilePanel}>
      <p className={styles.intro}>Manage your name, photo, and password.</p>
      <ProfileInformationSection
        key={userSignature}
        userProfile={userProfile}
        currentUserContext={currentUserContext}
        isLoading={isUserLoading}
      />
      <ChangePasswordSection />
    </section>
  );
}
